import { throwErrorMessage, throwSuccessMessage, throwWarning } from '../../lib/error_helper';
import { fetchWithTimeout } from '../../lib/fetch_wrapper';
import { distinct } from '../../utils';
import { setEquipmentEPIFormSectionsAction, formsIsLoading, actualizeNumberEPIToCheck, epiIsLoading } from './epiActions';
import { isVisible } from '../humanResources/humanResourcesActions'

export function openEquipmentEPIForm(history) {
    return () => {
        history.push("/epis/epi/form");
    };
}

export function responseValueChange(sectionId, metaQuestion, sections) {
    return (dispatch) => {
        let copyOfSections = sections.concat();
        let section = copyOfSections.find((b) => b.id === sectionId);

        if (!section) {
            console.error("La section est introuvable");
            return;
        }

        let metaQuestionIndex = section.questions.findIndex((mq) => mq.id === metaQuestion.id);

        if (metaQuestionIndex === undefined || metaQuestionIndex === null) {
            console.error("La réponse est introuvable");
            return;
        }

        section.questions.splice(metaQuestionIndex, 1, metaQuestion)
        dispatch(setEquipmentEPIFormSectionsAction(copyOfSections))
    }
}

export function validateEquipmentInspection(form, sections, equipmentInspection, activeUser, history) {
    return (dispatch) => {
        let formOk = dispatch(checkFormIntegrity(sections));

        if (!formOk)
            return;

        const headers = new Headers({ "Content-Type": "application/json" });
        let questions = [];
        sections.forEach(s => questions = questions.concat(s.questions));
        let lastState = equipmentInspection.equipment_to_review_id.state;
        dispatch(formsIsLoading(true));

        fetchWithTimeout("/api/v1/epi/save_form", {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                userId: activeUser.id,
                form,
                questions,
                validate: true,
                equipmentInspectionId: equipmentInspection.id
            }),
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((response) => {
                dispatch(formsIsLoading(false));
                dispatch(actualizeNumberEPIToCheck(activeUser));                
                dispatch(
                    throwSuccessMessage({
                        title: "Le formulaire a été envoyé",
                    })
                );
                var result = response[equipmentInspection.id];
                if (result) {
                    if (result.message_success){
                        dispatch(
                            throwWarning({
                                title: result.message_success,
                            })
                        );
                    }   
                    if (result.equipment_state.trim() == "operational" && lastState.trim() != result.equipment_state.trim()) {
                        dispatch(
                            throwSuccessMessage({
                                title: "L'équipement est désormais opérationnel",
                            })
                        );   
                    }                 
                }
                history.push("/epis");
            })
            .catch((err) => {
                console.error(
                    "Erreur : epiEditionActions - validateEquipmentInspection",
                    err
                );

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de l'envoi du formulaire équipement !",
                    })
                );

                dispatch(formsIsLoading(false));
            });
    }
}

export function checkFormIntegrity(sections) {
    return (dispatch) => {
        let allQuestionsOk = true;

        sections.sort(s => s.sequence).forEach(s => {
            s.questions.sort(q => q.sequence).forEach(question => {

                if (!allQuestionsOk)//On ne vérifie pas les autres sections si une section n'est pas correctement remplie pour éviter les traitements inutiles et le flood de message
                    return;

                let response = question.response_lines[0];
                let responseAnswers = response.response_answers.filter(ra => !ra.deleted);

                if (
                    //(
                    !question.is_require_answer //&& response.state !== "draft") 
                    || question.type === "descriptive_text" || !isVisible(sections, question))
                    return;

                if (question.is_conditional) {
                    let conditionalQuestion;

                    sections.forEach(section => {
                        if (!conditionalQuestion)
                            conditionalQuestion = section.questions.find(q => q.id === question.triggering_question_id);
                    })

                    if (!conditionalQuestion || conditionalQuestion.response_lines.length <= 0)
                        return;

                    let currentResponses = conditionalQuestion.response_lines[0].response_answers;

                    if (!currentResponses.find(ra => !ra.deleted && ra.answer_id === question.triggering_answer_id))
                        return;
                }

                let questionOk = true;

                if (question.type === "matrix_of_choices_only_multi_ans" || question.type === "matrix_of_choices_only_one_ans") {
                    let rowsIdsAnswered = responseAnswers.filter(ra => ra.value_choice).map(ra => ra.answer_id).filter(distinct);
                    questionOk = rowsIdsAnswered.length === question.answer_choice_ids.length ? true : false;
                } else if (question.type === "table") {
                    questionOk = true;//Un tableau ne peut-être requis
                } else if (question.type === "rating_scale") {
                    let rowsIdsAnswered = responseAnswers.filter(ra => ra.column_id).map(ra => ra.answer_id).filter(distinct);
                    questionOk = rowsIdsAnswered.length === question.answer_choice_ids.length ? true : false;
                } else if (question.type === "date" || question.type === "date_and_time") {
                    questionOk = responseAnswers.length > 0 && responseAnswers[0].answer ? true : false;
                } else if (question.type === "single_textbox" || question.type === "numerical_textboxes") {
                    questionOk = response.single_text ? true : false;
                } else if (question.type === "comment" || question.type === "multiple_textboxes" || question.type === "multiple_textboxes_diff_type") {
                    questionOk = response.comment ? true : false;
                } else if (question.type === "multiple_choice_only_one_ans" || question.type === "multiple_choice_multiple_ans") {
                    questionOk = responseAnswers.length > 0 && responseAnswers[0].answer_id ? true : false;
                } else {
                    questionOk = false;
                }

                if (!questionOk) {
                    dispatch(throwErrorMessage({
                        title: "Le formulaire n'est pas rempli",
                        message: "Veuillez répondre à la question [" + question.question + "]"
                    }))

                    allQuestionsOk = false;
                }
            })
        })

        return allQuestionsOk;
    }
}

export function submitAsDraft(equipmentEPIState, activeUser, onSuccess){
    return (dispatch) => {
        dispatch(epiIsLoading(true));
        const headers = new Headers({'Content-Type': 'application/json'});
        const body = JSON.stringify({
            equipmentEPI: equipmentEPIState,
            userId: activeUser.id,
        });

        fetchWithTimeout('/api/v1/equipmentsEPI/submitEPIAsDraftRequest', {
            method: 'POST',
            headers: headers,
            body: body,
        })
            .then((response) => {                
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                return response;
            })
            .then((response) => response.json())
            .then(() => {
                dispatch(throwSuccessMessage({
                    title: "Succès",
                    message: "L'équipement a bien été enregistré au statut brouillon !" ,
                }));
                if (onSuccess && typeof onSuccess === "function")
                    onSuccess()
                dispatch(epiIsLoading(false));
            }).catch((err) => {
                console.error("Erreur : epiEditionActions - submitAsDraft: " + err.message)
                dispatch(throwErrorMessage({title: "Erreur lors de la sauvegarde de l'équipement au statut brouillon !"}));
                dispatch(epiIsLoading(false));
            });
    }
}